<template>
    <div class="w-100 flex" id="sub-nav-container">
        <div class="sub-nav-menu-item main-nav-items" style="padding: 18px 18px 3px; ">
            <nav id="admin-sub-nav">
                <ul id="admin-sub-nav-bar-list">
                    <li class="admin-sub-nav-item">
                        <span class="sub-nav-link">
                        <a href="/portal-order-view/my-orders" id="orders-submitted-by-me-link" data-test="orders-submitted-by-me">
                            <span :class="showingMyOrders">
                                Orders Submitted by Me
                            </span>
                        </a>
                        </span>
                    </li>
                    <li class="admin-sub-nav-item" v-if="accountViewMode === 'company'" id="company-orders-link">
                        <span class="sub-nav-link">
                            <a href="/portal-order-view/show-company-orders" data-test="show-company-orders-link">
                                <span :class="showingCompanyOrders">
                                    Company Orders
                                </span>
                            </a>
                        </span>
                    </li>
                    <li class="admin-sub-nav-item" v-if="accountViewMode === 'group'" id="group-orders-link">
                        <span class="sub-nav-link">
                            <a href="/portal-order-view/show-group-orders" data-test="show-group-orders-link">
                                <span :class="showingGroupOrders">
                                    Group Orders
                                </span>
                            </a>
                        </span>
                    </li>
                </ul>
            </nav>
        </div>
        <div>
            <div class="flex admin-sub-nav-menu-right view-selector-bg">
                <div class="flex admin-sub-nav-menu-right-container">
                    <div style="margin: 9px 10px auto;">
                        View Orders From:
                    </div>
                    <label>
                        <v-select
                            data-test="on-behalf-account-component"
                            placeholder="Select User"
                            append-to-body
                            class="admin-sub-nav-menu-select"
                            :clearable="false"
                            label="fullname"
                            @input="orderFromUserSelected"
                            :reduce="u => u.id"
                            :value="this.proxyUser"
                            :options="viewableUsers"
                        >
                            <template #open-indicator="{ attributes }">
                                <span v-bind="attributes"><chevron-down-icon :size="24"/></span>
                            </template>
                            <template slot="option" slot-scope="option">
                                <div v-tooltip="option.fullname">
                                    {{ option.fullname }}
                                </div>
                            </template>
                            <template slot="no-options">
                                Type name to find users
                            </template>
                        </v-select>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import {ChevronDownIcon} from "../icons";
import {mapState} from "vuex";

export default {
    name: "ProjectManagerSubNavBar",
    beforeMount() {
        axios.get('/sub-nav')
            .then(response => {
                this.data = response.data.sub_nav_data;
                const {view_mode, proxy_user, account_users, account_orders_mode} = this.data;
                if (view_mode === "proxy") {
                    this.proxyUser = proxy_user.fullname;
                } else if (view_mode === "me"){
                    this.proxyUser = this.sessionUser.fullName;
                }
                this.showingCompanyOrders = view_mode === 'co' ? 'bold' : '';
                this.showingGroupOrders = view_mode === 'grp' ? 'bold' : '';
                this.showingMyOrders = view_mode === 'me' ? 'bold' : '';
                this.viewableUsers = account_users;
                this.accountViewMode = account_orders_mode
            })
            .catch(e => {
                console.log('Something went wrong!');
            });
    },
    components: {ChevronDownIcon},
    data() {
        return {
            data: undefined,
            proxyUser: undefined,
            viewableUsers: [],
            accountViewMode: "",
            showingCompanyOrders: false,
            showingGroupOrders: false,
            showingMyOrders: false
        }
    },
    computed: {
        ...mapState('AuthStore', {
            sessionUser: 'user',
            sessionAccount: 'account',
        }),
    },
    methods: {
        orderFromUserSelected(value) {
            if (value == '0') {
                window.location.href = `/portal-order-view/show-account-manager-company-admin-orders`;
            } else {
                window.location.href = `/portal-order-view/show-orders-from?user_id=${value}`;
            }
        },
        mouseover: function () {
            this.isOpen = true;
        },
        mouseleave: function () {
            this.isOpen = false;
        }
    }
}
</script>

<style>

#sub-nav-container {
    background: #ffffff;
    height: 24px;
    color: black;
    flex-direction: row;
    justify-content: space-between;
}

.sub-nav-menu-item {
    padding: 0 10px;
}

header {
    color: black;
    width: 100%;
    background-color: #fff;
}

#admin-sub-nav {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
}

#admin-sub-nav > ul {
    display: flex;
    margin-top: 16px;
    margin-bottom: 0;
    padding: 0;
    align-items: center;
    list-style-type: none;
}


.admin-sub-nav-item {
    margin: 10px 5px;
    font-size: 13px !important;
}

#admin-sub-nav > ul > li > span {
    position: relative;
    display: block;
    height: auto;
    color: #006699;
    text-decoration: none;
    cursor: pointer;
}

#admin-sub-nav > ul > li > span:after {
    display: inline-block;

}

.dropdown li a {
    color: #333333;
    font-size: 12px;
    padding: 5px 5px 5px 8px;
    display: block;
}

.dropdown {
    position: absolute;
    top: 100%;
    left: -3px;
    display: none;
    padding: 0;
    list-style-type: none;
    z-index: 9999;
    width: 176px;
    background-color: #FFFFFF;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%);
    border: 1px solid #EEEEEE;
    border-bottom: 0;
    border-radius: 5px;
    margin: -2px 0 0;
}

.dropdown li a:hover {
    background-color: rgba(50, 134, 186, .1);
    color: #006699;
}

.isOpen {
    display: grid;
    width: 850px;
    grid-template-columns: repeat(5, 1fr);
}

.admin-sub-nav-menu-right {
    height: 52px;
    font-size: 12px;
}

.admin-sub-nav-menu-right-container {
    margin: 8px
}

.bold {
    font-weight: bold;
}

.view-from-radio-label {
    margin: auto 5px;
}

.admin-sub-nav-menu-select {
    width: 225px;
    font-size: 12px;
    padding-right: 5px;
    max-height: 100px;
}

.vs__selected-options {
    flex-wrap: nowrap;
    max-width: calc(100% - 25px); /* change this to `- 40px` if you're supporting a `clearable` field; I was not */
}

.vs__selected {
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;
    overflow: hidden;
}

.vs__dropdown-option {
    font-size: 13px;
    margin: 2px -10px;
    text-overflow: ellipsis;
    overflow: hidden;
}

.vs__no-options {
    font-size: 12px;
}

.vs__dropdown-option--highlight {
    background: #006699;
    color: #fff;
    text-overflow: ellipsis;
    overflow: hidden;
}

</style>
